import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import { LangProvider } from "@/contexts/LangContext";
import { SettingsProvider } from "@/contexts/SettingsContext";

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <LangProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </BrowserRouter>
        </LangProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
